import { format } from '@breezeway/brzw-react-core';
/* eslint-disable camelcase */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Col, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import classnames from 'classnames';
import { Field } from 'redux-form';
import moment from 'moment';
import _ from 'lodash';

import TASK_CONST from '@shared/task/constants';
import CONST from '../../constants';
import FormControlSelectRow from '../form_control_select_row';
import CheckboxControl from '../checkbox_control';
import BrzwDatePicker from '../../../brzw_date_picker';

class FormControlDateTimePickerWithRecurring extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTime: !_.isEmpty(_.get(props, 'start_time.input.value')),
      showRecurring:
        !_.isEmpty(_.get(props, 'frequency.input.value')) &&
        !_.isEmpty(_.get(props, 'start_date.input.value')) &&
        !_.isEmpty(_.get(props, 'end_date.input.value')),
      time: _.get(props, 'start_time.input.value') || props.defaultTime,
    };

    this.onDateChange = this.onDateChange.bind(this);
    this.onDateRecurranceChange = this.onDateRecurranceChange.bind(this);
    this.recurrenceLabel = this.recurrenceLabel.bind(this);
    this.toggleRecurring = this.toggleRecurring.bind(this);
    this.toggleTime = this.toggleTime.bind(this);
  }

  // end_date #TODO change this for BR-4005

  onDateChange(pickedDate) {
    const { start_date: date, start_time: time } = this.props;
    const { showTime } = this.state;

    if (!pickedDate) {
      date.input.onChange(null);
      time.input.onChange(null);
    } else {
      const formattedDate = pickedDate.format('YYYY-MM-DD');

      date.input.onChange(formattedDate);

      if (showTime) {
        const formattedTime = pickedDate.format('HH:mm');

        time.input.onChange(formattedTime);
        this.setState({
          time: formattedTime,
        });
      }
    }
  }

  onDateRecurranceChange(pickedDate) {
    const { end_date: endDate } = this.props;
    if (!pickedDate) {
      endDate.input.onChange(null);
    } else {
      const formattedDate = pickedDate.format('YYYY-MM-DD');
      endDate.input.onChange(formattedDate);
    }
  }

  toggleTime() {
    const { start_time: startTime } = this.props;

    this.setState({ showTime: !this.state.showTime }, () => {
      if (!this.state.showTime) {
        startTime.input.onChange(null);
      } else {
        startTime.input.onChange(this.state.time);
      }
    });
  }

  toggleRecurring() {
    this.setState({ showRecurring: !this.state.showRecurring });
  }

  recurrenceSwitchLabel(type, time) {
    const { start_date: startDate } = this.props;
    const startDateValue = _.get(startDate, 'input.value');
    const formattedText = preText => {
      if (preText && time) return `(${preText} at ${time})`;
      else if (preText) return `(${preText})`;
      else if (time) return `(at ${time})`;
      return '';
    };

    const formattedDate = (date, dateFormat) => moment(date).format(dateFormat || 'dddd');
    const lastDays = [28, 29, 30, 31];
    const dayIsLastOfMonth = _.includes(lastDays, _.toInteger(formattedDate(startDateValue, 'D')));

    switch (type.value) {
      case 'day':
        return `${type.label} ${formattedText()}`;
      case 'week':
        return `${type.label} ${formattedText(`on ${formattedDate(startDateValue)}`)}`;
      case 'bi_weekly':
        return `${type.label} ${formattedText(`on ${formattedDate(startDateValue)}`)}`;
      case 'month':
        if (dayIsLastOfMonth) {
          return `${type.label} ${formattedText('on the last day of the month', 'Do')}`;
        }
        return `${type.label} ${formattedText(`on the ${formattedDate(startDateValue, 'Do')}`)}`;
      case 'quarter':
        if (dayIsLastOfMonth) {
          return `${type.label} ${formattedText('on the last day of the month', 'Do')}`;
        }
        return `${type.label} ${formattedText(`on the ${formattedDate(startDateValue, 'Do')}`)}`;
      case 'year':
        return `${type.label} ${formattedText(`on ${formattedDate(startDateValue, 'MMM Do')}`)}`;
      default:
        return '';
    }
  }

  recurrenceLabel(type) {
    const { time, showTime } = this.state;
    return this.recurrenceSwitchLabel(
      type,
      showTime ? format.datetime.formatTime(time) : undefined,
    );
  }

  render() {
    const {
      className,
      classNameContainer,
      start_date: date,
      hideRecurringCheckbox,
      id,
      isClearable,
      label,
      required,
      start_time: time,
      end_date: endDate,
    } = this.props;

    const { showTime, showRecurring } = this.state;

    let validationState = null;
    const dataTouched = _.get(date, 'meta.touched');
    const endDataTouched = _.get(endDate, 'meta.touched');
    const dateErrorText = dataTouched && _.get(date, 'meta.error');
    const timeErrorText = _.get(time, 'meta.touched') && _.get(time, 'meta.error');
    const endDateErrorText = endDataTouched && _.get(endDate, 'meta.error');

    if (dataTouched || endDataTouched) {
      if (dateErrorText || timeErrorText || endDateErrorText) {
        validationState = 'danger';
      } else {
        validationState = 'success';
      }
    }

    let selected;
    if (_.get(date, 'input.value')) {
      if (_.get(time, 'input.value')) {
        selected = moment(`${date.input.value}T${time.input.value}`);
      } else {
        selected = moment(date.input.value);
      }
    }

    let selectedRecurrance;
    if (_.get(endDate, 'input.value')) {
      selectedRecurrance = moment(endDate.input.value);
    }

    return (
      <FormGroup row className={classnames('form-group-row -with-recurring', classNameContainer)}>
        <div className="form-group-row__label-container">
          <Label
            for={`${id}-date`}
            className="form-group-row__label form-group-row__label-with-checkbox"
          >
            {required ? (
              <span>
                {label} <span className="text-orange">*</span>
              </span>
            ) : (
              label
            )}
          </Label>
          <div className="form-group-row__checkboxes">
            <div className="time-picker-checkbox">
              <Input
                checked={showTime}
                id={`${id}-checkbox-time`}
                onChange={this.toggleTime}
                type="checkbox"
              />
              <Label
                for={`${id}-checkbox-time`}
                className="form-group-row__label form-group-row__visible-label"
              >
                Add Time
              </Label>
            </div>
            {!hideRecurringCheckbox && (
              <div className="time-picker-checkbox">
                <CheckboxControl
                  id={`${id}-checkbox-recurring`}
                  name="checkbox_recurring"
                  label="Repeat"
                  onChange={this.toggleRecurring}
                />
              </div>
            )}
          </div>
        </div>

        <Col className="form-group-row__col mb-2">
          <BrzwDatePicker
            dateFormat={showTime ? 'dddd, MMMM D, YYYY @ h:mma' : 'dddd, MMMM D, YYYY'}
            inputClassName={classnames(
              'form-control form-group-row__input',
              className,
              validationState,
            )}
            isClearable={isClearable}
            onChange={this.onDateChange}
            selected={selected}
            showTimeSelect={showTime}
            futureOnly
          />
          <FormFeedback>{dateErrorText}</FormFeedback>
        </Col>

        {showRecurring && (
          <Fragment>
            <Col className="form-group-row__col">
              <Field autoBlur component={FormControlSelectRow} label="Repeating" name="frequency">
                {_.map(TASK_CONST.FREQUENCY_OPTIONS, frequency => (
                  <option key={frequency.value} value={frequency.value}>
                    {this.recurrenceLabel(frequency)}
                  </option>
                ))}
              </Field>
            </Col>
            <Col className="form-group-row__col">
              <div className="form-group-row__label-container">
                <label className="form-group-row__label ">Stop Repeating on</label>
              </div>
              <BrzwDatePicker
                dateFormat="dddd, MMMM D, YYYY"
                inputClassName={classnames(
                  'form-control form-group-row__input',
                  className,
                  validationState,
                )}
                isClearable={isClearable}
                onChange={this.onDateRecurranceChange}
                selected={selectedRecurrance}
                futureOnly
              />
              <FormFeedback>{endDateErrorText}</FormFeedback>
            </Col>
          </Fragment>
        )}
      </FormGroup>
    );
  }
}

FormControlDateTimePickerWithRecurring.propTypes = {
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  defaultTime: PropTypes.string,
  hideRecurringCheckbox: PropTypes.bool,
  id: PropTypes.string,
  isClearable: PropTypes.bool,
  label: PropTypes.string,
  required: PropTypes.bool,
  start_date: PropTypes.shape({
    input: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
  start_time: PropTypes.shape({
    input: PropTypes.shape({
      onChange: PropTypes.func,
      value: PropTypes.string,
    }),
  }),
  end_date: PropTypes.shape({
    input: PropTypes.shape({
      onChange: PropTypes.func,
      value: PropTypes.string,
    }),
  }),
};

FormControlDateTimePickerWithRecurring.defaultProps = {
  defaultTime: CONST.DEFAULT_TIME,
  hideRecurringCheckbox: false,
  isClearable: false,
  required: false,
};

export default FormControlDateTimePickerWithRecurring;
